import { type HTMLAttributes, forwardRef } from 'react';

import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

type TCaptchaContainerProps = HTMLAttributes<HTMLDivElement> & {
  version: 'v2' | 'v3';
};

const useStyles = makeStyles(
  ({ custom, shape }) => ({
    root: () => ({
      backgroundColor: '#f9f9f9',
      border: `1px solid ${custom.outline}`,
      borderRadius: shape.borderRadius,

      '& > div': {
        margin: 'auto',
        padding: 3,
      },

      '& > div > div': {
        height: '100%',
        overflow: 'hidden',
      },

      '& iframe': {
        margin: -2,
        verticalAlign: 'top',
      },

      '&[data-compact="true"]': {
        '& > div': {
          padding: 7,
        },

        '& iframe': {
          margin: -6,
        },
      },
    }),

    hidden: {
      display: 'none',
    },
  }),
  {
    name: 'CaptchaContainer',
  },
);

export const CaptchaContainer = forwardRef<HTMLDivElement, TCaptchaContainerProps>(
  ({ className, version, ...props }, ref) => {
    const classes = useStyles();

    return (
      <div
        ref={ref}
        className={clsx({
          [classes.root]: classes.root,
          [classes.hidden]: version !== 'v2',
          [className ?? '']: className,
        })}
        {...props}
      />
    );
  },
);

CaptchaContainer.displayName = 'CaptchaContainer';
